import ConfiguracaoSetorModel from "@/models/configuracaoSetorModel";
import nfetch from "@/utils/events/nfetch";

import { IService } from "./base/iService";

export default class ConfiguracaoSetorService extends IService<ConfiguracaoSetorModel> {
    constructor() {
        super("ConfiguracaoSetor");
    }

    public getByFranquia(): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetByFranquia`, {
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
        });
    }
}
